import React from "react";
import QuotesContent from "../components/quotes/quotes-content";

const Quotes = () => {
  return <QuotesContent />;
};

export default Quotes;
